export { default as Header } from './Header';
export { default as MobileHeader } from './MobileHeader';



// WEBPACK FOOTER //
// ./src/js/common/components/Header/index.js